import React, { Component } from 'react';

class ModalConfirmFrecuentes extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
		};
	}

	render() {
		return (
			<div className="overlay-modal row hide-modal" id={this.props.name || 'confirmFrecuentesModal'}>
				<div className="modal-delete">
					<form className="flex justify-center">
						<div className="full column align-center">
							<div className="white-space-32"></div>
							<div className="column container">
								<i className="fas fa-exclamation-circle color-purple fa-5x text-center"></i>
								<div className="white-space-24"></div>
								<h3 className="text-center">Al configurar esto, cualquier residente podra generar codigos QR desde su app.</h3>
							</div>
							<div className="white-space-32"></div>
							<div className="full">
								{this.state.loading ? (
									<button type="button" className="btn-modal-delete-success">
										<i className="fas fa-spinner fa-spin"></i>
									</button>
								) : (
									<button type="button" className="btn-modal-delete-success" onClick={this.handleConfirm.bind(this)}>
										<i className="fas fa-check" /> &nbsp; CONFIRMAR
									</button>
								)}
								<button type="button" className="btn-modal-delete-cancel" onClick={this.closeModal.bind(this)}>
									<i className="fas fa-times" /> &nbsp; CERRAR
								</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		);
	}

	openModal() {
		const modal = document.getElementById(this.props.name || 'confirmFrecuentesModal');
		if (modal) {
			modal.classList.remove('hide-modal');
			modal.classList.add('show-modal');
		}
	}

	closeModal() {
		const modal = document.getElementById(this.props.name || 'confirmFrecuentesModal');
		if (modal) {
			modal.classList.remove('show-modal');
			modal.classList.add('hide-modal');
		}
		this.setState({ loading: false });
	}

	async handleConfirm() {
		this.setState({ loading: true });
		try {
			if (this.props.onConfirm) {
				await this.props.onConfirm();
			}
			this.closeModal();
		} finally {
			this.setState({ loading: false });
		}
	}
}

export default ModalConfirmFrecuentes;
